import React, { useEffect } from "react";

const PackagModel = ({ isOpen, closeModal, children }) => {
  // if (!isOpen) {
  //   return null;
  // }

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (isOpen && event.target.classList.contains("modal-overlay")) {
        closeModal();
      }
    };

    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [isOpen, closeModal]);

  if (!isOpen) {
    return null;
  }

  return (
    // <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
    //   <div className="relative w-auto max-w-6xl mx-auto my-6">

    //     <div className="relative flex flex-col w-full bg-white border-0 rounded-lg shadow-lg outline-none focus:outline-none">

    //       <div className="relative p-6 flex-auto">
    //         <div>
    //           <h1 className="text-2xl font-bold">Package</h1>
    //           <button
    //             className=""
    //             onClick={closeModal}
    //           >
    //             <span className="text-black h-6 w-6 text-2xl font block outline-none focus:outline-none">
    //               ×
    //             </span>
    //           </button>
    //         </div>
    //         <div>{children}</div>
    //       </div>
    //     </div>
    //   </div>
    // </div>

    <>
      {/* <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
        <div className="relative w-auto max-w-6xl mx-auto my-auto">
          <div className="relative flex flex-col w-full bg-white bg-opacity-10 border-0 rounded-lg shadow-lg outline-none focus:outline-none">
            <div className="relative flex-auto">{children}</div>
            <div className="flex justify-end mt-3">
            <button
                className=""
                onClick={closeModal}
              >
               <span className="text-white h-6 w-6 text-2xl font block outline-none focus:outline-none">
                  ×
                </span>
              </button>
              
            </div>
          </div>
        </div>
      </div> */}

      <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
        <div
          className="modal-overlay relative w-auto max-w-6xl mx-auto my-auto"
          onClick={closeModal}
        >
          <div className="relative flex flex-col w-full bg-white bg-opacity-10 border-0 rounded-lg shadow-lg outline-none focus:outline-none">
            <div className="relative flex-auto">{children}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PackagModel;
